import { authService } from '../services/authService';
import { API_CONFIG } from '../config/api';

export const getHeaders = () => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  // Add token if available
  const token = authService.getToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Add selected country if available
  const selectedCountry = localStorage.getItem('selectedCountry');
  if (selectedCountry) {
    const country = JSON.parse(selectedCountry);
    headers['SELECTED-COUNTRY'] = country.code;
  }

  return headers;
};

export const getFormDataHeaders = () => {
  const headers: HeadersInit = {};

  // Add token if available
  const token = authService.getToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Add selected country if available
  const selectedCountry = localStorage.getItem('selectedCountry');
  if (selectedCountry) {
    const country = JSON.parse(selectedCountry);
    headers['SELECTED-COUNTRY'] = country.code;
  }

  return headers;
};

export const rejectNews = async (newsId: number) => {
  const response = await fetch(`${API_CONFIG.BASE_URL}/admin/news/reject/${newsId}`, {
    method: 'GET',
    headers: getHeaders()
  });

  if (!response.ok) {
    throw new Error('Failed to reject news');
  }

  // Get the response as text instead of trying to parse as JSON
  const text = await response.text();
  return text;
};